import React, { useContext, useEffect } from "react";
import Container from "../components/ui/Container";
import HeaderSection from "../components/ui/HeaderSection";
import LoadingIcon from "../components/ui/LoadingIcon";
import AuthContext from "../context/AuthContext";
import { isObjectEmpty } from "../utils/objects";
import { Outlet, NavLink } from "react-router-dom";
import AnimatingPage from "../middleware/AnimatingPage";
import CenterIcon from "../components/ui/CenterIcon";
import {
    isChargeInsertAuto,
    isLoginTokens,
    isMigrationFromInsertAuto,
    isWalletEnabled,
} from "../services/defaultSettings";
import page from "../services/pageServices";
import { useLanguage } from "../context/LanguageContext";

const User = () => {
    const { user } = useContext(AuthContext);
    const { language } = useLanguage();
    const content = {
        title: {
            en: "User Profile",
            ar: "ملف المستخدم",
            de: "Benutzerprofil",
        },
        loadingMessage: {
            en: "Loading your data...",
            ar: "يتم الآن تحميل بياناتك.....",
            de: "Laden Ihrer Daten...",
        },
        menu: {
            profile: {
                en: "User Profile",
                ar: "ملف المستخدم",
                de: "Benutzerprofil",
            },
            chargeInsert: {
                en: "Charge Center Code",
                ar: "شحن كود سنتر",
                de: "Zentrumscode aufladen",
            },
            migrateFromInsert: {
                en: "Center Lectures and Codes",
                ar: "محاضرات و اكواد السنتر",
                de: "Zentrumsvorlesungen und Codes",
            },
            wallet: {
                en: "My Wallet",
                ar: "محفظتي",
                de: "Mein Wallet",
            },
            courses: {
                en: "My Courses",
                ar: "كورساتي",
                de: "Meine Kurse",
            },
            loginData: {
                en: "Security and Login History",
                ar: "الآمان و تاريخ تسجيل الدخول",
                de: "Sicherheit und Anmeldeverlauf",
            },
            videoViews: {
                en: "Viewing Details",
                ar: "تفاصيل المشاهدات",
                de: "Anzeigedetails",
            },
            invoices: {
                en: "Invoices",
                ar: "الفواتير",
                de: "Rechnungen",
            },
            subscriptions: {
                en: "Subscriptions",
                ar: "الاشتراكات",
                de: "Abonnements",
            },
            examResults: {
                en: "Exam Results",
                ar: "نتائج الامتحانات",
                de: "Prüfungsergebnisse",
            },
            hmResults: {
                en: "Homework Results",
                ar: "نتائج الواجب",
                de: "Hausaufgabenergebnisse",
            },
        },
    };
    useEffect(() => {
        const currentTitle = page.getCurrentTitle();
        page.setTitle(content.title[language]);
        return () => {
            page.setTitle(currentTitle);
        };
    }, [language]);

    return (
        <>
            <div
                className={`${
                    language !== "ar" ? "en" : "ar"
                } bg-outer-container smooth clr-text-primary negative-nav-margin posisitve-nav-padding-top`}
            >
                <Container className="py-10 pb-10 space-y-0">
                    <HeaderSection></HeaderSection>
                    {isObjectEmpty(user) && (
                        <AnimatingPage>
                            <div className="relative z-10 w-full">
                                <div className="w-full flex-center-both flex-col">
                                    <div className="bg-inner-container clr-text-primary shadow-large rounded-md smooth px-8 py-10 w-full max-w-lg -mt-16 ">
                                        <span className="flex-center-both space-x-3 space-x-reverse">
                                            <LoadingIcon
                                                className={
                                                    "font-big text-teal-500 dark:text-teal-300"
                                                }
                                            />
                                            <span>{content.loadingMessage[language]}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </AnimatingPage>
                    )}
                    {!isObjectEmpty(user) && (
                        <AnimatingPage>
                            <Container>
                                <Container>
                                    <div className="bg-inner-container clr-text-primary px-5 py-10  rounded-md shadow-lg -mt-32 relative z-10 smooth border-2 border-slate-500 border-opacity-10">
                                        <div className="flex-center-both">
                                            <div className="flex flex-row font-h2 font-w-bold rounded-full shadow-lg overflow-hidden bg-thir-container clr-text-primary smooth border-2 border-slate-500 border-opacity-10 shrink-0">
                                                <div className="h-12 w-16 border-2 border-opacity-30 border-blue-200 flex-center-both bg-earthYellow-300 rounded-full clr-white">
                                                    <CenterIcon icon="carbon:user-avatar-filled" />
                                                </div>
                                                <div className="pl-6 pr-2 flex-center-both">
                                                    <div className="font-w-bold">
                                                        {content.title[language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col sm:flex-row pt-5">
                                            <div className="sm:basis-1/4 shrink-0 min-w-0 pb-5">
                                                <div className="relative w-full">
                                                    <div className="px-4 py-4  flex flex-col w-full space-y-3">
                                                        <NavLink
                                                            to="./home"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.profile[language]}
                                                        </NavLink>

                                                        {isChargeInsertAuto ? (
                                                            <NavLink
                                                                to="./charge_insert_auto"
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                        : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                                }
                                                            >
                                                                {
                                                                    content.menu.chargeInsert[
                                                                        language
                                                                    ]
                                                                }
                                                            </NavLink>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {isMigrationFromInsertAuto ? (
                                                            <NavLink
                                                                to="./migrate_from_insert_auto"
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                        : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                                }
                                                            >
                                                                {
                                                                    content.menu.migrateFromInsert[
                                                                        language
                                                                    ]
                                                                }
                                                            </NavLink>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {isWalletEnabled ? (
                                                            <NavLink
                                                                to="./wallet"
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                        : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                                }
                                                            >
                                                                {content.menu.wallet[language]}
                                                            </NavLink>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <NavLink
                                                            to="./courses"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.courses[language]}
                                                        </NavLink>

                                                        {isLoginTokens ? (
                                                            <NavLink
                                                                to="./login_data"
                                                                className={({ isActive }) =>
                                                                    isActive
                                                                        ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                        : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                                }
                                                            >
                                                                {content.menu.loginData[language]}
                                                            </NavLink>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <NavLink
                                                            to="./video_views"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.videoViews[language]}
                                                        </NavLink>
                                                        <NavLink
                                                            to="./invoices"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.invoices[language]}
                                                        </NavLink>
                                                        <NavLink
                                                            to="./subscriptions"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.subscriptions[language]}
                                                        </NavLink>
                                                        <NavLink
                                                            to="./exam_results"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.examResults[language]}
                                                        </NavLink>
                                                        <NavLink
                                                            to="./hm_results"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            {content.menu.hmResults[language]}
                                                        </NavLink>
                                                        {/* <NavLink
                                                            to="./video_quizes"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            نتائج كويز الفيديو
                                                        </NavLink> */}

                                                        {/* <NavLink
                                                            to="./notifications"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            الاشعارات
                                                        </NavLink> */}
                                                        {/* <NavLink
                                                            to="./"
                                                            className={({ isActive }) =>
                                                                isActive
                                                                    ? "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-earthYellow-300 clr-white  border-blue-100 border-opacity-20 smooth"
                                                                    : "py-2 px-3 rounded-md shadow-md border-2 clr-text-primary bg-primary-container border-slate-500 border-opacity-10 smooth hover:bg-opacity-0 hover:border-earthYellow-500 hover:text-earthYellow-500"
                                                            }
                                                        >
                                                            مؤشر المستوي
                                                        </NavLink> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="sm:basis-3/4 flex flex-col py-5 w-full overflow-auto">
                                                <Outlet />
                                            </div>
                                        </div>
                                    </div>
                                </Container>
                            </Container>
                        </AnimatingPage>
                    )}
                </Container>
            </div>

            {/* <AnimatePresence exitBeforeEnter>
                <div key={Object.keys(course).length}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        {Object.keys(course).length < 1 && (
                            <div className="h-screen negative-nav-margin grow w-full flex-center-both font-h2 col-span-1 md:col-span-2 lg:col-span-3">
                                <span className="flex-center-both space-x-3 space-x-reverse bg-teal-500 px-28 py-12 clr-white rounded-2xl">
                                    <LoadingIcon
                                        className={"font-big text-teal-800 dark:text-teal-400"}
                                    />
                                    <span>يتم الآن تحميل بيانات الكورس.....</span>
                                </span>
                            </div>
                        )}
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        {Object.keys(course).length > 0 && (
                            <div className="bg-outer-container smooth clr-text-primary negative-nav-margin posisitve-nav-padding-top">
                                <Container className="py-10 pb-10">

                                    <HeaderSection course={course} />
                                    <Outlet />

                                    <ContentSection course={course} />
                                </Container>
                            </div>
                        )}
                    </motion.div>
                </div>
            </AnimatePresence> */}
        </>
    );
};

export default User;
